export default __webpack_public_path__ + "static/media/OFFSITEPM-dark.d5a50e93.svg";